import { createActions } from "redux-actions";
export enum editStateActionTypes {
  SET_IS_EDITING = "SET_IS_EDITING",
}

export const { setIsEditing } = createActions({
  [editStateActionTypes.SET_IS_EDITING]: (payload) => {
    return payload;
  },
});